const NotFound = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "4rem" }}>
      <h1>404</h1>
      <h2>Página no encontrada</h2>
      <p>La página que intentas visitar no existe.</p>
    </div>
  );
};

export default NotFound;